import { Voter } from "@activecollab/security";
import moment from "moment";
import { MEMBER_PERMISSIONS } from "~/records/record.project";
import { isMemberWithoutPermissions, isPowerClient } from "~/utils/userHelper";

export class CommentVoter extends Voter {
  attributes = ["delete", "edit", "create-task", "view-edited"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Comment";
  }

  getCommentProject(subject) {
    try {
      let projectId = 0;
      if (subject.parent_type === "Task") {
        const task = this.state.tasks.get(`${subject.parent_id}`);
        if (task) {
          projectId = task.project_id;
        }
      }
      if (subject.parent_type === "Discussion") {
        const discussion = this.state.discussions[subject.parent_id];
        if (discussion) {
          projectId = discussion.project_id;
        }
      }
      if (subject.parent_type === "Note") {
        const note = this.state.notes[subject.parent_id];
        if (note) {
          projectId = note.project_id;
        }
      }
      const projects = this.state.projects;
      return projects.get(`${projectId}`);
    } catch (e) {
      console.error(e);
    }
  }

  getCommentCalendar(subject) {
    try {
      const calendarEvent = this.state.calendarEvents[subject.parent_id];

      const calendars = this.state.calendars;
      return calendars[calendarEvent.calendar_id];
    } catch (e) {
      console.error(e);
    }
  }

  canEditComment(subject, user) {
    if (subject.is_trashed) {
      return false;
    }

    if (user.class === "Owner") {
      return true;
    }

    if (subject.parent_type === "CalendarEvent") {
      const calendar = this.getCommentCalendar(subject);

      if (!calendar) {
        return false;
      }

      if (calendar.created_by_id === user.id) {
        return true;
      }
    } else {
      const project = this.getCommentProject(subject);

      if (!project) {
        return false;
      }

      if (project.leader_id === user.id) {
        return true;
      }
    }

    if (subject.created_by_id === user.id && subject.created_on) {
      const globalLockEditValue = this.state.config_options.get("lock_comments_after_minutes");
      if (globalLockEditValue === 0) {
        return true;
      }
      return subject.created_on + globalLockEditValue * 60 > moment().utc().unix();
    }

    return false;
  }

  canViewEdited(subject, user) {
    if (subject.is_trashed) {
      return false;
    }

    if (user.class === "Client") {
      return false;
    }

    const ownerCompanyId = this.state.config_options.get("owner_company_id");

    if (ownerCompanyId && ownerCompanyId === user.company_id) {
      return Boolean(subject.last_modification_on);
    }

    return false;
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "delete":
      case "edit": {
        return this.canEditComment(subject, user);
      }
      case "create-task": {
        if (user.class === "Client") {
          if (isPowerClient(user)) {
            return true;
          }
          return false;
        }

        const project = this.getCommentProject(subject);

        if (
          project?.member_permissions === MEMBER_PERMISSIONS.STRICT &&
          isMemberWithoutPermissions(user) &&
          project?.leader_id !== user?.id
        ) {
          return false;
        }

        return true;
      }
      case "view-edited": {
        return this.canViewEdited(subject, user);
      }
    }

    throw new Error("This code should not be reached!");
  }
}
